<template>
	<main>
		<div class="m-header" :class="[is_top ? '' : 'active']">
			<div class="top"></div>
		</div>
		<div class="banner-swiper">
			<div class="swiper-container" id="banner-swiper">
				<div class="swiper-wrapper">
					<div class="swiper-slide">
						<div class="banner">
							<div class="top-box">
								<div class="title-box">
									<div class="live" @click="toLive" v-if="user_info.id">{{ banner_btn.text }}</div>
									<div class="btn" @click="kvToRegister" v-if="!user_info.id">{{ banner_btn.text }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- Add Pagination -->
				<div class="swiper-pagination"></div>
			</div>
		</div>

		<div class="s1">
			<div class="content" v-html="adv1.desc"></div>
		</div>
		<div class="s4">
			<div class="center">
				<div class="content">
					<div class="list">
						<div class="list2">
							<div class="item item-1" @click="util.toLink('/plan')">
								<div class="info">
									<div class="tit">主会场</div>
									<div class="m-tit">KEYNOTE</div>
									<div class="line"></div>
								</div>
							</div>
						</div>
						<div class="list2">
							<div class=" item item-2" @click="util.toLink('/branch')">
								<div class="info">
									<div class="tit">分论坛</div>
									<div class="m-tit">BREAKOUT SESSION</div>
									<div class="line"></div>
								</div>
							</div>
							<div class=" item item-3" v-if="!is_offline"
								@click="util.toLink('https://www.dellemc-solution.com/dtfbooth/2026/goglobal')">
								<div class="info">
									<div class="tit">线上展区</div>
									<div class="m-tit">ONLINE BOOTH</div>
									<div class="line"></div>
								</div>
							</div>
							<div class=" item item-3" v-else @click="util.toLink('/offline')">
								<div class="info">
									<div class="tit">线下活动</div>
									<div class="m-tit">OFFLINE EVENTS</div>
									<div class="line"></div>
								</div>
							</div>
						</div>
						<div class="list2">
							<div class=" item item-4" @click="util.toLink('/guest')">
								<div class="info">
									<div class="tit">嘉宾介绍</div>
									<div class="m-tit">SPEAKER</div>
									<div class="line"></div>
								</div>
							</div>

							<div class=" item item-5" v-if="is_login" @click="util.toLink('/ucenter/plan')">
								<div class="info">
									<div class="tit">我的日程</div>
									<div class="m-tit">MY AGENDA</div>
									<div class="line"></div>
								</div>
							</div>
							<div class=" item item-5" v-else @click="util.toLink('/ucenter/plan')">
								<div class="info">
									<div class="tit">我的日程</div>
									<div class="m-tit">MY AGENDA</div>
									<div class="line"></div>
								</div>
							</div>
						</div>
					</div>
					<div class="list">
						<div class="list2">
							<div class=" item item-6" @click="util.toLink('/interact/paper')">
								<div class="info">
									<div class="tit">调查问卷</div>
									<div class="m-tit">SURVEY</div>
									<div class="line"></div>
								</div>
							</div>
						</div>
						<div class="list2">
							<div class=" item item-8" @click="util.toLink('/contact/sponsor')">
								<div class="info">
									<div class="tit">赞助商</div>
									<div class="m-tit">SPONSOR</div>
									<div class="line"></div>
								</div>
							</div>
						</div>
						<div class="list2">
							<div class=" item item-7" @click="util.toLink('/contact/dell')">
								<div class="info">
									<div class="tit">联系戴尔</div>
									<div class="m-tit">contact dell</div>
									<div class="line"></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="s5" v-if="false">
			<div class="center">
				<div class="common-title">
					<div class="left title">解锁超多精彩内容</div>
					<div class="right more" @click="util.toLink('/video')">查看更多</div>
				</div>
				<div class="content">
					<div class="list">
						<div class="item" v-for="(item, index) in adv4" v-if="index < 2" @click="playS4Video(item)">
							<div class="image-box">
								<div class="image"
									:style="{ backgroundImage: 'url(' + (item.image ? util.autoImage(item.image) : util.autoImage(item.video) + '?x-oss-process=video/snapshot,t_0,f_jpg,m_fast') + ')' }">
									<div class="play"></div>
								</div>
								<div class="tit">{{ item.category_title }}</div>
							</div>
							<div class="info">
								<div class="element-more min-tit">{{ item.title }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="book-success" v-if="book_success">
			<div class="mark"></div>
			<div class="content">
				<div class="close" @click="book_success = false;"></div>
				<div class="middle">
					<div class="title">{{ book_info.title }}</div>
					<div class="m-title" v-html="book_info.desc"></div>
				</div>
			</div>
		</div>
		<video-float v-if="video_info.video" :video_info="video_info" @hideVideo="video_info = {}"></video-float>
	</main>
</template>

<script>
import VideoFloat from "../../components/m/VideoFloat";
export default {
	name: 'home',
	data() {
		return {
			query: "",
			swiper_1: "",
			swiper_2: "",
			s1_play_show: true,
			s4_play_show: -1,
			logo: [require('@/assets/image/49.png'), require('@/assets/image/50.png')],
			swiper: "",
			room_list: [],
			adv2: [],
			adv2_index: 0,
			adv4: [],
			adv5: {
				kv_status: 1,
			},
			adv6: {},
			book_success: false,
			book_info: {},
			video_info: {},

			speaker: [],
			is_top: true,
		}
	},
	components: {
		VideoFloat
	},
	computed: {
		adv1() {
			var _text = {
               	"title":"大会介绍",
				"desc":`<p> 2026年，企业级AI已从“技术探索期”迈入 “规模应用与价值兑现期” 。技术正在重构企业运营方式，驱动决策自动化、流程重塑与业务模式创新。多数企业虽已启动AI布局，真正实现可规模复制、可衡量ROI的企业仍属少数。进化差距，正在迅速扩大。与此同时，中国企业全球化迈入深水区。从规模扩张走向高质量增长，从单点突破走向系统化本地运营，企业对数字底座、数据治理与安全合规提出了前所未有的要求。</p>
                <p>在这一关键节点，我们诚挚邀请您出席：<i>2026 戴尔科技峰会暨「进化者」论坛</i>，与来自各行业的领军企业决策者与技术领袖，共同洞察AI驱动下的更优「进化路径」，把握下一阶段增长的主动权。</p>
                <p>峰会核心价值：</p>
                <p>让AI落地见效，驱动业务增长：构建融合算力、数据与安全的AI原生底座，加速智能体在核心业务中的规模化应用，实现可量化回报。</p>
                <p>重构成本模型，进入Token经济时代：从算力投入走向精细化管理，优化AI成本结构，提升每一分投入的产出效率。</p>
                <p>释放组织生产力，打造AI原生工作方式：以AI PC与终端算力为支点，让AI能力普惠到每一位员工，提升整体决策与执行效率。</p>
				<p>构建可信AI体系，平衡创新与安全：以主权AI与零信任架构为核心，确保数据安全、模型可靠与智能体行为可控。</p>
				<p>支持全球化发展，夯实数字化底座：以一致架构与本地合规能力，助力企业实现高质量全球化运营。</p>`
			};
			// if(this.util.isOffline()){//线下
			// 	_text = {
			// 		"title":"大会介绍",
			// 		"desc":`<p>2026“重启复苏”之年，创新成为经济增长新驱动力。随着经济、技术和社会环境的变化，企业的机遇与挑战并存，可谓既有风口也有浪尖，而数字技术的价值在这个关键时刻则进一步凸显，<i>复苏亟须抓住“突破性创新”关键</i>。</p><p>“数实融合”作为数字化转型的主题核心，也是未来五年数字化转型和高质量发展的主要趋势（IDC）。企业需要在<i>“韧性”和“混合创新力”</i>的双驱动升级下，寻求“稳中制胜”的关键，通过在技术、管理和商业模式上持续提升，开辟新的业务增长点，为企业行稳致远、高质量发展夯实基础。</p><p>风物长宜放眼量，<i>创新是企业赖以生存发展的灵魂，是企业持续发展的保证</i>。戴尔科技集团作为持续深耕数实融合、以“务实的创新”为根本的践行者，通过全面的数字化服务能力和世界级创新技术，聚焦企业当前发展面临的<i>几大核心挑战</i>：</p><p>1.<i>降本增效</i>提升产出，找到新业务增长点</p><p>2.企业出海<i>全球化布局</i>，全球化运营可视化、合规化</p><p>3.区域化深耕服务多样化，<i>业务场景愈发复杂</i>，亟须高度灵活IT架构，打造末端灵活</p><p>4.数据价值挑战，<i>让数据真正流动起来</i></p><p>5.勒索攻击、数据泄露、供应链攻击高发，<i>安全</i>成为制约企业健康发展的生命线</p><p>我们希望与众多的数字决策者们一起深度挖掘数字业务的新动能，预见技术世界的新秩序，开辟数实融合的新格局。</p><p>8月18日，<i>“2026戴尔科技峰会”</i>如约而至。本次峰会以<i>“新·生万物 数实新格局”</i>为主题，届时，戴尔科技集团携手各行业的创新力量为您<i>深入剖析数实融合的成功案例和最佳实践，深度自动化、智能化、云化和边缘加速的创新路径，共同探索在新格局下的发展趋势和机遇</i>。衷心邀请您参与本届创新峰会，共同加速“新·生万物数实新格局”的创新之旅。</p>`
			// 	}
			// }
			return _text;
		},
		is_offline() {
			return this.util.isOffline();
		},
		live_btn() {
			var status = this.adv5.kv_status;
			var text = "";
			if (status == 1) {
				if (this.user_info.id) {
					text = "大会直播敬请期待"
				} else {
					text = "立即报名"
				}
			}
			if (status == 2) {
				text = "正在直播"
			}
			if (status == 3) {
				text = "直播回放"
			}
			return text;
		},
		banner_btn() {
			const ds = '2026-08-21';
			var myDate = parseInt(new Date().getTime() / 1000);
			if (myDate < this.tool.date.strtotime(`${ds} 09:00:00`)) {
				return {
					text: this.user_info.id ? "敬请期待" : '立即报名',
				}
			} else if (myDate >= this.tool.date.strtotime(`${ds} 09:00:00`) && myDate < this.tool.date.strtotime(`${ds} 12:00:00`)) {
				return {
					text: "大会正在直播",
					link: "/plan"
				}
			} else if (myDate >= this.tool.date.strtotime(`${ds} 12:00:00`) && myDate < this.tool.date.strtotime('2026-08-21 00:00:00')) {
				return {
					text: "大会正在直播",
					link: "/branch"
				}
			} else {
				return {
					text: "观看大会回放",
					link: "/plan"
				}
			}
		},
		user_info() {
			return this.$store.state.user_info;
		},
		is_login() {
			return this.util.getAccessToken()
		}
	},
	methods: {
		bannerLink(item) {
			gio('track', 'DTF2021_homekv_videoplay');
			if (item.link) {
				window.location.href = item.link;
			}
		},
		toLive() {
			// gio('track', 'DTF2021_homekv_Watchlive');
			// this.util.showWait(true);
			// return false;
			if (this.banner_btn.link) {
				this.util.toLink(this.banner_btn.link);
			}
			var myDate = parseInt(new Date().getTime() / 1000);
			// if(myDate < this.tool.date.strtotime('2026-08-15 12:00:00') || myDate >= this.tool.date.strtotime('2026-08-17 00:00:00')){
			if (myDate < this.tool.date.strtotime('2026-08-21 12:00:00')) {
				this.util.toLink('/plan')
			} else {
				this.util.toLink('/branch')
			}
		},
		kvToRegister() {
			gio('track', 'DTF2021_homekv_signup');
			this.util.toLink('/login')
		},
		kvToVideo() {
			gio('track', 'DTF2021_homekv_videoplay');
			this.util.toLink('/video')
		},
		listenScroller() {
			window.onscroll = () => {
				this.is_top = !(document.documentElement.scrollTop || document.body.scrollTop);
			}
		},
		swiperInit() {
			// this.swiper = new Swiper('#banner-swiper',{
			// 	autoplay: {
			// 		delay: 5000,
			// 		disableOnInteraction: false,
			// 	},
			// 	loop: true,
			// 	pagination: {
			// 		el: '.swiper-pagination',
			// 		clickable:true,
			// 	},
			// })
		},
		setAdv2Index(index) {
			this.adv2_index = index;
			this.$nextTick(() => {
				this.playVideo();
			})
		},
		playS4Video(item) {
			gio('track', 'DTF2021_videoclick', {
				DTF2021_videotitle: item.title,
			});

			item.video = item.url;
			this.video_info = item;
		},
		stopS4Video(index) {
			var video = document.getElementById('s4_video_' + index);
			video.pause();
		},
		toRegister() {
			if (this.adv5.kv_status == 1) {
				if (this.user_info.id) {
					return false;
				} else {
					this.util.toLink('/register')
				}
			} else {
				if (this.adv5.link) {
					var url = this.global.MUDU_HOST + this.adv5.link;
					if (this.user_info.id) {
						var router = this.$router.resolve({
							path: "/auth",
							query: {
								live_code: this.adv5.link,
								redirect: url
							}
						});
						window.open(router.href, '_blank');
					} else {
						var from = "/auth?live_code=" + this.adv5.link + "&redirect=" + url
						this.util.showAuth({
							show: true,
							from: from,
							target: "_blank"
						});
					}
				} else {
					this.$router.push({
						path: "/branch"
					})
				}
			}
		},
		toSession(item) {
			var url = this.global.MUDU_HOST + item.live_code;
			var router = this.$router.resolve({
				path: "/auth",
				query: {
					redirect: url
				}
			});
			window.open(router.href, '_blank');
		},
		playVideo() {
			var item = this.adv2[this.adv2_index];
			item.video = item.url;
			this.video_info = item;
		},
		stopVideo() {
			var video = document.getElementById('s1_video');
			video.pause();
		},
		getAdv3() {
			this.http.request({
				api: "adv/getAdv",
				data: {
					position: 3,
				},
				loading: true,
				success: (res) => {
					var adv3 = res.adv && res.adv.length > 0 ? res.adv[0] : {};
					adv3.link ? this.util.toLink(adv3.link) : this.util.showWait(true)
				}
			})
		},
		refresh() {
			this.timer = setInterval(() => {
				var myDate = new Date();
				var now_time = parseInt(myDate.getTime() / 1000);
				if (now_time == this.tool.date.strtotime('2022-08-25 09:00')) {
					this.getAdv5()
				}
			}, 1000)
		},
		getSpeakerList() {
			this.http.request({
				api: "speaker/getSpeakerList",
				data: {
					is_top: 1,
				},
				success: (res) => {
					this.speaker = res.list;
				}
			})
		},
		getVideoList() {
			this.http.request({
				api: "video/getVideoList",
				data: {
					type: 2,
				},
				success: (res) => {
					this.adv2 = res.list;
				}
			})
			this.http.request({
				api: "video/getVideoList",
				data: {
					type: 3,
				},
				success: (res) => {
					this.adv4 = res.list;
				}
			})
		},
		getAdv6() {
			this.http.request({
				api: "adv/getAdv",
				data: {
					position: 4,
				},
				success: (res) => {
					this.adv6 = res.adv[0];
				}
			})
		},
		getAdv5() {
			this.http.request({
				api: "adv/getAdv",
				data: {
					position: 19,
				},
				success: (res) => {
					this.adv5 = res.adv[0];
				}
			})
		},
	},
	mounted() {
		this.query = this.$route.query;
		this.swiperInit();
		this.getVideoList();
		this.getSpeakerList();
		this.refresh();
		this.getAdv5();
		this.getAdv6();
		this.listenScroller();
		this.util.showBottom(true)
	},
	destroyed() {
		clearInterval(this.timer);
	}
}
</script>

<style lang="scss" type="text/scss" scoped>
.m-header {
	.top {
		position: fixed;
		height: .88rem;
		overflow: hidden;
		top: 0;
		left: 0;
		width: 100%;
		z-index: 99;
		background: url("~@/assets/image/2026/mobile/home-kv.png") no-repeat top center;
		background-size: 100% 4.6rem;
		opacity: 0;
		transition: all .3s ease;
	}
}

.m-header.active {
	.top {
		opacity: 1;
		transition: all .3s ease;
	}
}

.banner-swiper {
	.swiper-container {
		.swiper-wrapper {
			.swiper-slide {
				.banner {
					height: 4.6rem;
					background: url("~@/assets/image/2026/mobile/home-kv.png") no-repeat top center;
					background-size: 100% 4.6rem;
					text-align: center;
					color: #fff;
					position: relative;

					.top-box {
						text-align: center;

						.title-box {
							display: block;
							padding-top: 1.2rem;
							padding-left: 0.2rem;
							color: #fff;
							text-align: left;

							.title {
								width: 5.91rem;
								height: 1.53rem;
								margin-top: 0;
								background: url("~@/assets/image/2026/slogan01.png") no-repeat center center;
								background-size: contain;
							}

							.zzs {
								width: 4.2rem;
								height: 0.36rem;
								margin-top: 0.3rem;
								background: url("~@/assets/image/2026/zzs01.png") no-repeat center center;
								background-size: 100% auto;
							}

							.m-title {
								display: none;
								margin-top: -.9rem;
								margin-left: .5rem;

								.img {
									width: 2.9rem;
									height: .35rem;
									margin-right: .9rem;
									background: url("~@/assets/image/83.png") no-repeat center center;
									background-size: contain;
								}
							}

							.btn {
								position: absolute;
								left: 0.3rem;
								bottom: 0.8rem;
								width: 2.4rem;
								height: .7rem;
								background: #cbeeff;
								text-align: center;
								color: #00227F;
								font-size: .28rem;
								font-weight: bold;
								line-height: .7rem;
								transition: all .3s ease;
								cursor: pointer;
								border-radius: 0.06rem;
							}

							.live {
								position: absolute;
								left: 0.3rem;
								bottom: 0.8rem;
								width: 2.4rem;
								height: .7rem;
								background-color: #cbeeff;
								text-align: center;
								color: #00227F;
								font-size: .28rem;
								font-weight: bold;
								line-height: .7rem;
								transition: all .3s ease;
								cursor: pointer;
								border-radius: 0.06rem;
							}

							.logo {
								position: absolute;
								bottom: -.6rem;
								right: .55rem;
								width: 2.72rem;
								height: .33rem;
								background: url("~@/assets/image/logo.png") no-repeat center center;
								background-size: contain;
								display: none;
							}
						}

						.logo-box {
							position: absolute;
							bottom: .25rem;
							width: 100%;
							display: none;

							.box {
								float: left;
								margin-left: .25rem;

								img {
									width: 2.35rem;
								}
							}

							.live-btn {
								float: right;
								position: absolute;
								bottom: 0;
								right: .25rem;
								height: 1rem;
								font-size: .4rem;
								text-align: center;
								line-height: 1rem;
								padding: 0 .6rem;
								background: #a8375c;
								color: #fff;
								transform: scale(.5);
								transform-origin: bottom right;
							}
						}
					}
				}

				.banner2 {
					height: 4.6rem;
					background: url("~@/assets/image/2021/44.jpg") no-repeat top center;
					background-size: 100% 4.6rem;
					text-align: center;
					color: #fff;
					position: relative;

					.top-box {
						padding-left: .35rem;

						.middle {
							height: 4.6rem;
							text-align: left;

							.title {
								font-size: .44rem;
								font-weight: bold;
							}

							.min-title {
								font-size: .28rem;
								margin-top: .2rem;
								width: 70%;
							}

							.btn {
								display: block;
								width: 1.77rem;
								height: .46rem;
								margin-top: .4rem;
								background: url("~@/assets/image/2021/41.png") no-repeat center center;
								background-size: 100% 100%;
								cursor: pointer;
							}
						}
					}
				}
			}
		}

		.swiper-pagination {
			::v-deep .swiper-pagination-bullet {
				width: .14rem;
				height: .08rem;
				background: rgba(255, 255, 255, .4);
				border-radius: 4px;
				opacity: 1;
				transition: all .3s ease;
			}

			::v-deep .swiper-pagination-bullet.swiper-pagination-bullet-active {
				width: .24rem;
				height: .08rem;
				background: rgba(255, 255, 255, 1);
				transition: all .3s ease;
			}
		}
	}
}

.common-title {
	overflow: hidden;
	font-size: .41rem;
	line-height: .54rem;
	color: #C8C9C7;
	padding: .25rem 0;

	.title {
		color: #1D56C0;
	}

	.en-title {
		margin-left: .1rem;
		font-weight: 100;
	}

	.more {
		font-size: .22rem;
		color: #808080;
		padding-right: .12rem;
		background: url("~@/assets/image/58_2.png") no-repeat right center;
		background-size: .1rem;
	}
}

.s1 {
	.content {
		width: 6.5rem;
		margin: .5rem auto;
		font-size: .24rem;
		line-height: .36rem;
		color: #444444;

		::v-deep p {
			margin-bottom: .36rem;

			i {
				color: #0032c2;
				font-weight: 700;
			}
		}
	}
}

.s4 {
	padding: .2rem .4rem .4rem;
	position: relative;

	.content {
		.list {
			overflow: hidden;
			display: flex;
			width: 100%;
			margin-bottom: .16rem;

			.item {
				height: 1.8rem;
				position: relative;
				background: url("~@/assets/image/2021/11.png") no-repeat center center;
				background-size: cover;

				.info {
					position: absolute;
					top: .2rem;
					left: .2rem;
					color: #fff;

					.tit {
						font-size: .26rem;
						font-weight: bold;
						line-height: .36rem;
					}

					.m-tit {
						font-size: .16rem;
						line-height: .3rem;
						text-transform: uppercase;
					}

					.line {
						width: .28rem;
						height: .03rem;
						background: #F2AF00;
						margin-top: .06rem;
					}
				}
			}

			.list2 {
				margin-right: .16rem;
				flex: 1;
			}

			.list2:nth-last-child(1) {
				margin-right: 0;
			}

			@for $i from 1 through 8 {
				.item-#{$i} {
					background: url("~@/assets/image/2021/#{27+$i}.png") no-repeat center center;
					background-size: cover;
				}
			}
		}

		.list:nth-child(1) {
			.item {
				margin-bottom: .16rem
			}

			.item:nth-last-child(1) {
				margin-bottom: 0;
			}

			.list2:nth-child(1) {
				.item {
					height: 3.98rem;
				}
			}

			.list2:nth-child(2) {
				.item:nth-child(2) {
					height: 2.02rem;
				}
			}

			.list2:nth-child(3) {
				.item:nth-child(1) {
					height: 2.2rem;
				}

				.item:nth-child(2) {
					height: 1.62rem;
				}
			}
		}

		.list:nth-last-child(1) {
			margin-bottom: 0;
		}
	}
}

.s5 {
	display: block;
	clear: both;
	padding: .5rem .4rem 1rem;
	background: url("~@/assets/image/2024/mobile/bottom_bg.png") no-repeat bottom center;
	background-size: cover;
	position: relative;

	.common-title {
		margin-left: .1rem;
	}

	.content {
		.list {
			overflow: hidden;

			.item {
				float: left;
				width: 3.2rem;
				margin-right: .29rem;
				text-align: left;
				transition: all .3s ease;

				.image-box {
					position: relative;

					.image {
						height: 1.72rem;
						background: url("~@/assets/image/11.png") no-repeat center center;
						background-size: cover;
						position: relative;

						.play {
							width: .5rem;
							height: .5rem;
							position: absolute;
							top: 50%;
							left: 50%;
							background: url("~@/assets/image/2021/7.png") no-repeat left center;
							background-size: contain;
							margin-left: -.25rem;
							margin-top: -.25rem;
							cursor: pointer;
							z-index: 2;
						}
					}

					.image::after {
						content: "";
						display: block;
						position: absolute;
						top: 0;
						left: 0;
						width: 100%;
						height: 100%;
						background: rgba(0, 0, 0, .5);
						z-index: 1;
					}

					.tit {
						font-size: .2rem;
						position: absolute;
						bottom: 0;
						right: 0;
						padding: 0 .1rem 0 .35rem;
						height: .4rem;
						line-height: .4rem;
						background: url("~@/assets/image/2021/27.png") no-repeat center center;
						background-size: 100% 100%;
						text-align: center;
						color: #fff;
						z-index: 2;
					}
				}

				.info {
					margin-top: .2rem;
					box-sizing: border-box;

					.min-tit {
						font-size: .24rem;
						color: #1D56C0;
						line-height: .33rem;
						min-height: .66rem;
						-webkit-line-clamp: 2;
					}
				}
			}

			.item:nth-child(2n) {
				margin-right: 0;
			}
		}
	}
}

.book-success {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 1000;

	.mark {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, .8);
	}

	.content {
		position: absolute;
		left: 50%;
		top: 50%;
		width: 6.9rem;
		height: 4rem;
		background: url("~@/assets/image/2026/success-kv.png") no-repeat center center;
		background-size: cover;
		color: #fff;
		transform: translate(-50%, -50%);
		border-radius: .1rem;

		.close {
			width: .5rem;
			height: .5rem;
			position: absolute;
			top: 0;
			right: 0;
			background: url("~@/assets/image/54.png") no-repeat center center;
			background-size: .25rem;
			cursor: pointer;
			transition: background .3s ease;
		}

		.middle {
			width: 6.9rem;
			height: 4rem;
			text-align: center;

			.title {
				font-size: .4rem;
			}

			.m-title {
				font-size: .3rem;
				margin-top: .4rem;
				line-height: .5rem;
			}
		}
	}
}
</style>
